import { IContainerItem } from "./ContainerSchemas";

export function formatDate(dateStr: string): string {
    if (!dateStr) return '';
    const date = new Date(dateStr);

    const options: Intl.DateTimeFormatOptions = {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        hour12: true
    };

    return date.toLocaleString('en-US', options).replace(', ', ',').replace(' at', '');
}

export function getFolderPathRelativeToContainer(folderPath: IContainerItem[]): string {
	return folderPath.map((item) => item.name).join('/');
}

/**
 * Checks if a file is previewable (PDF or image) based on its file extension
 * @param fileName - The name of the file including extension
 * @returns true if the file is a PDF or image, false otherwise
 */
export function isPreviewableFile(fileName: string): boolean {
	if (!fileName) return false;
	
	const extension = fileName.toLowerCase().split('.').pop();
	if (!extension) return false;
	
	// Supported image formats
	const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', 'svg'];
	// Supported document formats
	const documentExtensions = ['pdf'];
	
	const supportedExtensions = [...imageExtensions, ...documentExtensions];
	
	return supportedExtensions.includes(extension);
}
